import { track, trackCustom } from '../lib/pixel'

export function trackPixel(event: string, data?: Record<string, any>) {
  // no-op
}

export function trackAndNavigate(
  event: string,
  data: Record<string, any>,
  url: string,
) {
  window.setTimeout(() => {
    window.location.href = url
  }, 250)
}

export { track, trackCustom }
